import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import ProductHeader from "../components/productheader"
import ProductSection from "../components/productsection"
import Four1 from "../images/4iiii1.jpg"
import Four2 from "../images/4iiii2.jpg"
import Four3 from "../images/4iiii3.jpg"
import Four4 from "../images/4iiii4.jpg"

const ObviousCheckout = () => (
  <Layout>
    <SEO
      title="4iiii Ecommerce Website
    "
    />
    <div className="relative max-w-screen-lg mx-auto">
      <ProductHeader
        title="4iiii's Ecommerce Website"
        subtitle="Front-end | Design"
      />
      <ProductSection image={Four1} />
      <ProductSection image={Four2} />
      <ProductSection image={Four3} />
      <ProductSection image={Four4} />
    </div>
  </Layout>
)

export default ObviousCheckout
